export const IconProfile = () => <i className='icon-profile'/>
